import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#basic-usage" }),
  /*#__PURE__*/_createTextVNode(" Basic usage ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Displays the amount of new messages. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("comments")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("replies")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("comments")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("replies")
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "el-dropdown-link" }, [
  /*#__PURE__*/_createTextVNode(" Click Me"),
  /*#__PURE__*/_createVNode("i", { class: "el-icon-caret-bottom el-icon--right" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" comments ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" replies ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_badge = _resolveComponent("el-badge")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_badge, {
        value: 12,
        class: "item"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { size: "small" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_badge, {
        value: 3,
        class: "item"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { size: "small" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_badge, {
        value: 1,
        class: "item",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { size: "small" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_badge, {
        value: 2,
        class: "item",
        type: "warning"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { size: "small" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_dropdown, { trigger: "click" }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { class: "clearfix" }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _createVNode(_component_el_badge, {
                    class: "mark",
                    value: 12
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { class: "clearfix" }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _createVNode(_component_el_badge, {
                    class: "mark",
                    value: 3
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code1), 1)
        ]),
        _: 1
      })
    ])
  ]))
}